import { useStore } from 'react-redux';

export const useInjectReducer = (key, reducer) => {
    const store = useStore();

    if (!store.getState()[key]) {
        store.injectReducer(key, reducer);
    }
};
